export const ALERT_ACTION_NOTIFY_WEBHOOK = 'notifyWebhook';

export function isNotifyWebhookAlertAction(functionName: string | undefined): boolean {
  if (functionName === undefined) {
    return false;
  }
  return functionName.trim().toLowerCase() === 'notifywebhook';
}

export interface AlertAction {
  function: string;
  parameters?: Record<string, string | boolean | number>;
}

export interface AlertType {
  id: string;
  description: string;
  examples: string[];
  actions?: AlertAction[];
  deletedAt?: string;
  standard?: boolean;
  disabled?: boolean;
}

export type AlertActionStatus = 'active' | 'scoped' | 'legacy';

export interface AlertActionDefinition {
  function: string;
  label: string;
  description: string;
  status: AlertActionStatus;
  statusLabel: string;
}

export const ALERT_ACTION_CATALOG: AlertActionDefinition[] = [
  {
    function: 'sendWebhook',
    label: 'Enviar a webhooks',
    description: 'Envía la alerta a todos los webhooks activos del proyecto (Slack, Teams, Google Chat).',
    status: 'active',
    statusLabel: 'Activa',
  },
  {
    function: 'alertToExecutive',
    label: 'Avisar al ejecutivo',
    description: 'Notifica al ejecutivo asignado del cliente. Solo aplica a clientes reales (no pruebas).',
    status: 'active',
    statusLabel: 'Activa',
  },
  {
    function: 'sendGoogleChatMessage',
    label: 'Mensaje a Google Chat',
    description: 'Publica un mensaje en un espacio de Google Chat (requiere URL).',
    status: 'active',
    statusLabel: 'Activa',
  },
  {
    function: 'notifyPazCorp',
    label: 'Notificar a Pazcorp',
    description: 'Integración exclusiva del proyecto Pazcorp.',
    status: 'scoped',
    statusLabel: 'Solo Pazcorp',
  },
  {
    function: 'notifyWebhook',
    label: 'notifyWebhook (legacy)',
    description: 'Sin efecto en el backend actual. Migrar a "Enviar a webhooks".',
    status: 'legacy',
    statusLabel: 'Legacy',
  },
];

export function getAlertActionDefinition(fn: string): AlertActionDefinition | undefined {
  const normalized = fn.trim().toLowerCase();
  return ALERT_ACTION_CATALOG.find((def) => def.function.toLowerCase() === normalized);
}
